
import React from "react";
import { Col, Row } from "react-bootstrap";

import Python from "../../Assets/TechIcons/Python.svg";
import AWS from "../../Assets/TechIcons/AWS.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import SQL from "../../Assets/TechIcons/SQL.svg";
import Postman from "../../Assets/TechIcons/Postman.svg";
import Go from "../../Assets/TechIcons/go.svg";
import C from "../../Assets/TechIcons/C++.svg";
import Node from "../../Assets/TechIcons/Node.svg";

function Techstack() {
  const technologies = [
    { name: "Python", image: Python },
    { name: "AWS", image: AWS },
    { name: "Docker", image: Docker },
    { name: "Git", image: Git },
    { name: "SQL", image: SQL },
    { name: "Postman", image: Postman },
    { name: "Go", image: Go },
    { name: "C++", image: C },
    { name: "Node.js", image: Node },
    { name: "Linux", image: null },
    { name: "Networking", image: null },
    { name: "Security Research", image: null },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {technologies.map(({ name, image }) => (
        <Col
          xs={4}
          md={2}
          className="tech-icons"
          key={name}
          title={name}
        >
          {image ? (
            <img
              src={image}
              alt={name}
              style={{
                width: "45px",
                height: "45px",
                objectFit: "contain",
              }}
            />
          ) : (
            <div
              style={{
                height: "45px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "15px",
                fontWeight: "600",
              }}
            >
              {name === "Linux" ? "CLI" : name === "Networking" ? "NET" : "SEC"}
            </div>
          )}

          <div className="tech-icons-text">{name}</div>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
